// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"175":"513311df","453":"28504b54","867":"9ad633a3"}[chunkId] + ".chunk.js";
};